import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[capitalize]'
})
export class CapitalizeDirective {
  constructor() {}

  @HostListener('input', ['$event']) onInputChange($event): void {
    $event.target.value = $event.target.value.replace(/^\w/, c =>
      c.toUpperCase()
    );
  }
}
